// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getById, getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetPickupWarehousesApiParameter } from "@store/Framework/Services/StoreWarehouseService";
import { createContext } from "react";

export function getPickupWarehouseState(state: ApplicationState, id: string | undefined) {
    return getById(state.store.data.pickupWarehouse, id);
}

export function getPickupWarehouseDataView(
    state: ApplicationState,
    getPickupWarehouseParameter: GetPickupWarehousesApiParameter,
) {
    return getDataView(state.store.data.pickupWarehouse, getPickupWarehouseParameter);
}

export const PickupWarehouseStateContext = createContext<ReturnType<typeof getPickupWarehouseState>>({
    value: undefined,
    isLoading: false,
    errorStatusCode: undefined,
    id: undefined,
});

export const PickupWarehouseDataViewContext = createContext<ReturnType<typeof getPickupWarehouseDataView>>({
    value: undefined,
    isLoading: false,
});
